export const SESSION_STORAGE_BIN_KEY = "localBin";

export function getStoredBinsFromSession() {
  return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_BIN_KEY) || "{}");
}
